<template>
  <div class="expense">
    <hearderCommon :text="text" style="margin-bottom: 40px"></hearderCommon>
    <van-dropdown-menu active-color="#74b42b" class="drop_down">
      <van-dropdown-item :title="dateTitle" ref="item">
        <van-datetime-picker
          :swipe-duration="500"
          v-model="search.deliveryTime"
          type="date"
          :show-toolbar="false"
          :formatter="formatter"
          close-on-click-outside
          @change="dateChange"
        />
        <div class="sure">
          <van-button @click="cancle('Time')" class="cancle" type="primary"
            >重置</van-button
          >
          <van-button @click="sure('Time')" class="mark" type="primary"
            >确认</van-button
          >
        </div>
      </van-dropdown-item>
      <van-dropdown-item
        v-model="search.status"
        :title="statusName ? statusName : '状态'"
        ref="statusPick"
      >
        <van-picker
          cancel-button-text="重置"
          @cancel="cancle('status')"
          @confirm="onConfirmStatus"
          show-toolbar
          toolbar-position="bottom"
          @change="cateChange"
          :columns="statusList"
        />
      </van-dropdown-item>
    </van-dropdown-menu>
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :immediate-check="false"
      :offset="100"
      @load="onLoad"
    >
      <div
        class="send"
        v-for="(one, index) in sendList"
        :key="index"
        @click="goParticular(one.orderId)"
        slot="default"
      >
        <p>
          <span class="left">
            订单编号：{{ one.orderCode }}
            <van-tag
              type="primary"
              v-if="one.goodsKindValue == '1'"
              color="#f2826a"
              >个性订单</van-tag
            >
          </span>
          <span class="right">{{ one.status | filterLabel(statusList) }}</span>
        </p>
        <p>
          <span class="price">配送地址：{{ one.deliveryName }}</span>
        </p>
        <p class="time">
          <span>配送日期：{{ one.deliveryTime | dateFil }}</span>
        </p>
        <!-- 订单详情列表 -->
        <div>
          <van-row
            type="flex"
            class="order"
            v-for="(two, index) in one.children.slice(0, 3)"
            :key="index"
          >
            <van-col span="15">
              <div class="van-ellipsis">{{ two.goodsName }}</div>
            </van-col>
            <van-col span="6" class="weight">
              <!-- ￥{{ two.confirmPrice }}/{{ two.saleUnitLabel }} -->
            </van-col>
            <van-col span="3" class="amount">x{{ two.orderQty }}</van-col>
          </van-row>
        </div>

        <div v-if="one.children.length > 3">...</div>
        <p class="total"> 
          <span class="ty-left">共{{ one.children.length }}个商品</span>
          <!-- <span class="ty-center">￥{{ one.totalPrice }}</span> -->
          <!-- <span class="ty-right">合计：</span> -->
        </p>
        <div class="line" v-if="one.status == '20'"></div>
        <van-row type="flex" justify="end" v-if="one.status == '20'">
          <van-button
            round
            type="info"
            size="mini"
            plain
            color="#74B42B"
            @click.stop="checking(one.orderId)"
            >确认收货</van-button
          >
        </van-row>
      </div>
      <div v-if="sendList.length == 0">
        <img src="../../assets/无订单.png" alt class="noList" />
        <p class="search-p">暂无订单</p>
      </div>
    </van-list>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";

export default {
  created() {
    this.onRefresh();
  },
  components: {
    hearderCommon,
  },
  data() {
    return {
      customerId: "", // 客户id
      sendList: [], // send列表
      text: "补货列表",
      //GQ
      loading: false,
      finished: false,
      current: 1,
      size: 10,
      statusName: "待收货",
      statusList: [
        { text: "待发货", value: 10, label: "待发货" },
        { text: "待收货", value: 20, label: "待收货" },
        { text: "待对账", value: 30, label: "待对账" },
        { text: "交易成功", value: 40, label: "交易成功" },
        { text: "交易关闭", value: 100, label: "交易关闭" },
      ],
      total: 0,
      error: false,
      dateTitle: `${new Date().getFullYear()} 年${
        new Date().getMonth() + 1
      }月${new Date().getDate()}日`,
      search: {
        deliveryTime: new Date(new Date().getTime()),
        status: "20",
        customerId: localStorage.getItem('customerId')
      }, 
    };
  },
  methods: {
    //GQ : 更新下一页数据
    onLoad() {
      // 数据全部加载完成
      if (this.sendList.length >= this.total) {
        this.finished = true;
        return;
      }
      this.$axios
        .post(
          `/trade/supplementCargo/cargoAndManifest/page?current=${this.current}&size=${this.size}&descs=update_time`,
          {
            needDtls: "1",  
            ...this.search,
          }
        )
        .then((res) => {
          if (res.data.code != 0 && res.data.data == null) {
            this.error = true;
          }
          this.current = res.data.data.current + 1;
          res.data.data.records.forEach((v) => {
            this.sendList.push(v);
          });
          this.loading = false;
        });
    },
    dateChange(picker) {
      this.dateTitle = picker.getValues().join("");
    },
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "date") {
        return `${value}日`;
      }
      return value;
    },
    sure(value) {
      if (value == "Time") {
        this.$refs.item.toggle();
      } else {
        this.$refs.line.toggle();
      }
      this.onRefresh();
    },
    cancle(value) {
      if (value == "Time") {
        this.$refs.item.toggle();
        this.search.deliveryTime = new Date();
        this.dateTitle = `${new Date().getFullYear()}年${
          new Date().getMonth() + 1
        }月${new Date().getDate()}`;
      } else {
        this.search.status = "20";
        this.statusName = "待收货";
        this.$refs.statusPick.toggle();
      }
      this.onRefresh();
    },
    onConfirmStatus(value) {
      this.search.status = value.value;
      this.statusName = value.text;
      this.$refs.statusPick.toggle();
      this.onRefresh();
    },
    // 获取列表
    async onRefresh() {
      this.loading = true;
      const ress = await this.$axios.post(
        `/trade/supplementCargo/cargoAndManifest/page?current=${this.current}&size=${this.size}&descs=update_time`,
        {
          needDtls: "1",
          ...this.search,
        }
      );
      this.sendList = ress.data.data.records;
      this.total = ress.data.data.total;
      this.current = ress.data.data.current;
      this.loading = false;
    },
    cateChange() {},
    // 确认对账
    checking(orderId) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "您确定要确认收货么？",
          confirmButtonColor: "#74b42b",
        })
        .then(() => {
          this.$axios
            .get(`/trade/supplementCargo/receive/${orderId}`)
            .then((res) => {
              if (res.data.code == 0) {
                this.$toast("收货 成功");
                this.onRefresh();
              }
            });
        });
    },
    goParticular(orderId) {
      this.$router.push({
        path: "/expense/detail",
        query: { orderId },
      });
    },
  },
};
</script>

<style scoped lang=scss>
.send {
  width: 90%;
  background-color: #fff;
  margin: 6px auto;
  border-radius: 10px;
  padding: 10px 10px 8px;
  box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
}
.van-list {
  padding-top: 48px;
}
.right {
  float: right;
  font-size: 12px;
  color: #74b42b;
}
.left {
  font-size: 14px;
  font-weight: 700;
}
.time {
  margin-bottom: 5px;
}
.order {
  font-size: 14px;
  line-height: 22px;
}
.weight {
  color: #f5a623;
}
.total {
  margin-top: 10px;
}
.ty-center,
.ty-right {
  float: right;
}
.ty-center {
  float: right;
  color: #f5a623;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
  margin-bottom: 5px;
  margin-top: 5px;
}
/* .van-button {
  padding: 1px 2px 2px 2px;
  line-height: 16px;
} */
.amount {
  text-align: right;
}
.van-button {
  padding: 1px 6px;
  /* line-height: 20px; */
  font-size: 12px;
}
.change {
  padding: 1px 18px 1px 18px !important;
}

.noList {
  width: 100%;
  height: 100%;
  margin-top: 100px;
}
.search-p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
}
</style>